module.exports = __webpack_public_path__ + "b5aed8aa56ad770c4bd8ea8c75821078.png";